import React from 'react';
import { faEllipsisVertical, faListCheck, faArrowRight, faUsers, faChartLine, faCalendar, faCog, faBell, faFileAlt, faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WidgetContainer } from '@frontend/app/refresh-components';
import { cn } from '@frontend/shadcn/lib/utils';
import { TaskCard } from './TaskCard';

interface CurrentTasksProps {
  projectId: number;
  className?: string;
}

export const CurrentTasks = ({ projectId: _projectId, className }: CurrentTasksProps) => {
  return (
    <WidgetContainer
      widgetTitle="Current Tasks"
      textColor="text-grey-6 text-sm"
      bgColor="bg-white"
      widgetIcon={<FontAwesomeIcon icon={faListCheck} className="text-grey-4" />}
      widgetActions={<FontAwesomeIcon icon={faEllipsisVertical} className="text-grey-6" />}
      className={cn('h-min', className)}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 w-full">
        <TaskCard
          icon={<FontAwesomeIcon icon={faArrowRight} className="text-xs" />}
          title="Create Campaign Workflow"
          description="Create a campaign workflow to follow each member's journey and progress."
          onClick={() => console.log('Create Campaign Workflow clicked')}
        />
        <TaskCard
          icon={<FontAwesomeIcon icon={faListCheck} className="text-xs" />}
          title="Review Content"
          description="Review and approve content before publishing."
          onClick={() => console.log('Review Content clicked')}
        />
        <TaskCard
          icon={<FontAwesomeIcon icon={faUsers} className="text-xs" />}
          title="Manage Team Members"
          description="Add, remove, and manage team member permissions and roles."
          onClick={() => console.log('Manage Team Members clicked')}
        />
        <TaskCard
          icon={<FontAwesomeIcon icon={faChartLine} className="text-xs" />}
          title="Analytics Dashboard"
          description="View campaign performance metrics and insights."
          onClick={() => console.log('Analytics Dashboard clicked')}
        />
        <TaskCard
          icon={<FontAwesomeIcon icon={faCalendar} className="text-xs" />}
          title="Schedule Posts"
          description="Plan and schedule content for optimal engagement times."
          onClick={() => console.log('Schedule Posts clicked')}
        />
        <TaskCard
          icon={<FontAwesomeIcon icon={faCog} className="text-xs" />}
          title="Configure Settings"
          description="Customize campaign settings and preferences."
          onClick={() => console.log('Configure Settings clicked')}
        />
        <TaskCard
          icon={<FontAwesomeIcon icon={faBell} className="text-xs" />}
          title="Notification Center"
          description="Manage alerts and notifications for campaign updates."
          onClick={() => console.log('Notification Center clicked')}
        />
        <TaskCard
          icon={<FontAwesomeIcon icon={faFileAlt} className="text-xs" />}
          title="Content Library"
          description="Access and organize your content assets and templates."
          onClick={() => console.log('Content Library clicked')}
        />
        <TaskCard
          icon={<FontAwesomeIcon icon={faStar} className="text-xs" />}
          title="Featured Campaigns"
          description="Highlight and showcase your best performing campaigns."
          onClick={() => console.log('Featured Campaigns clicked')}
        />
      </div>
    </WidgetContainer>
  );
};
